import { Dashboard } from 'app/area/dashboard/dashboard';
import { STATE } from 'app/constants';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { scrollToTop } from 'app/infrastructure/platform/routing';
import * as React from 'react';

import { startupTranslation } from './constants';
import { StartupState } from './types-store';
import { NewCaseBanner } from 'app/area/startup/components/new-case-banner';
import { LinksSection } from 'app/area/links-section/links-section';

type StartupProps = StartupState & DefaultContainerProps;

export class StartupComponent extends React.Component<StartupProps> {
  public static statePath: string = STATE.startupArea;

  public componentDidMount() {
    scrollToTop();
  }

  public render() {
    const { translation } = this.props;

    return (
      <>
        <div className="container main-grid">
          <NewCaseBanner
            textHeader={translation.new_case_header}
            textDescription={translation.new_case_description}
            textBtnRegisterNewCase={translation.new_case_register}
            textOpenCaseHeader={translation.open_case_header}
            textOpenCaseDescription={translation.open_case_description}
            textCaseNo={translation.open_case_case_no}
            textOpenCase={translation.open_case}
          />
        </div>
        <LinksSection />
        {(!!this.props.sharedState.startupDashboardId || !!this.props.sharedState.startupDashboardTypeId) && <div>
          <Dashboard
            dashboardType={this.props.sharedState.startupDashboardTypeId}
            requestedMainFavouriteId={this.props.sharedState.startupDashboardId}
            mainFavouriteReadOnly={true}
            showDescription={false}
            location={this.props.router.location}
            hideFilters={true}
          />
        </div>}
      </>
    );
  }
}

const container = containerFactory(StartupComponent, undefined, null, startupTranslation);
export { container as Startup };
